module.exports = __webpack_public_path__ + "img/hr-muzzle-flash.b82da57a.png";